import api from '@/services/api/tnc.js'
import { useState } from 'react'

const useTnc = () => {

	const [tnc, setTnc] = useState("")
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(payload) {

		const tnc = sessionStorage.getItem('tnc')
		if (tnc) {
			return setTnc(JSON.parse(tnc))
		}

		setLoading(true)
		const [error, response] = await api.getTnC(payload)
		setLoading(false)
		if (error) {
			return setTnc()
		}
		if (!(typeof response === 'object')) {
			return setError('TNC is not an object')
		}

		sessionStorage.setItem('tnc', JSON.stringify(response.html))
		setTnc(response.html)
		return
	}

	async function accept(payload) {

		const [error, response] = await api.acceptTnC(payload)

		if (error) {
			return setError('TNC Accept has error')
		}
		return [error, response]
	}

	return {
		error,
		fetch,
		accept,
		tnc
	}

}

export default useTnc
